import r from"./eq.js";var t=r;var e=function(r,e){for(var a=r.length;a--;)if(t(r[a][0],e))return a;return-1};export{e as default};
//# sourceMappingURL=_assocIndexOf.js.map
